import { Component, input } from '@angular/core';
import { SimpleTable } from './simple-table';
import { SimpleTableHeaderCellDef } from './simple-table-header-cell-def';
import { SimpleTableCellDef } from './simple-table-cell-def';
import { RxIconModule } from '@nrwl/rx-icon';
import { SimpleTableColumnDef } from './simple-table-column-def';
import { DatePipe } from '@angular/common';
import { MedicalNoteItem } from './medical-note-item';
import { EmrReadonlyNotice } from '../../../helpers/components/emr-readonly-notice';
import { ScribeSuggestionIndicatorComponent } from '../shared/scribe-suggestion-indicator/scribe-suggestion-indicator.component';
import { AmendmentFieldIndicatorComponent } from '../shared/amendment-field-indicator/amendment-field-indicator.component';

/**
 * Preview-only view for the Medical Notes widget shown in non-editing contexts.
 */
@Component({
  selector: 'fb-medical-notes-widget-preview',
  imports: [
    SimpleTable,
    SimpleTableColumnDef,
    SimpleTableHeaderCellDef,
    SimpleTableCellDef,
    RxIconModule,
    DatePipe,
    EmrReadonlyNotice,
    ScribeSuggestionIndicatorComponent,
    AmendmentFieldIndicatorComponent,
  ],
  templateUrl: './medical-notes-widget-preview.html',
  styleUrl: './medical-notes-widget-preview.scss',
})
export class MedicalNotesWidgetPreview {
  /**
   * Medical notes to be displayed.
   */
  public readonly data = input<readonly MedicalNoteItem[]>([]);

  /**
   * Whether the entity is in readonly mode.
   */
  public readonly isEmrReadonly = input(false);
  /**
   * Index of the note among the widget's stored notes, for the amendment indicator.
   */
  protected getAmendmentRowIndex(note: MedicalNoteItem): number {
    return this.data().indexOf(note);
  }
}
